import { isAndroid, isIOS, isMacOs, isWindows } from 'react-device-detect';
import { Button, Col, Grid, Row, Typography } from 'antd';

import ImageC from 'src/components/Image';

import classes from './index.module.less';

const DownloadContainer = () => {
	const { xs } = Grid.useBreakpoint();
	const OS = isAndroid
		? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID'
		: isWindows
		? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID'
		: isMacOs
		? 'https://apps.apple.com/id/app/hallobumil/id1507726157'
		: isIOS
		? 'https://apps.apple.com/id/app/hallobumil/id1507726157'
		: 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID';

	return (
		<div className={classes.pagehero}>
			<div className={classes['page-body-wrap']}>
				<div className="container">
					<Row>
						<Col md={24} sm={22} xs={24} lg={12} xl={12}>
							<div className={classes.section}>
								<p className={classes.title} style={{ marginBottom: '-5px' }}>
									Semua yang Mama dan Papa
									<br /> Butuhkan Ada di Hallobumil
								</p>

								<Typography className={classes.paragraph}>
									Dari perencanaan, kehamilan, hingga tumbuh kembang anak,
								</Typography>
								<Typography className={classes.paragraph}>
									semuanya lengkap di sini. Yuk, Download Ma!
								</Typography>
							</div>
							<div className={classes.btnFooter}>
								<Button
									className={classes.btn}
									onClick={() => window.open(OS)}
									size="large"
									id="download-sekarang"
								>
									Download Sekarang
								</Button>
							</div>
						</Col>
						<Col md={0} sm={2} xs={0} lg={12} xl={12}>
							<div style={{ textAlign: 'right' }}>
								<ImageC
									src="/images/branda/cta/mobile-bnr.webp"
									width={xs ? 325 : 433}
									height={xs ? 326 : 475} />
							</div>
						</Col>
					</Row>
				</div>
			</div>
		</div>
	);
};

export default DownloadContainer;
